import { useParams } from 'react-router-dom';

export const useIsChain = () => {
	const { shopId } = useParams();
	if (shopId) return false;
	return true;
};
